/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable @typescript-eslint/no-var-requires */
import type { ApolloCache } from '@apollo/client';
import { prismicConfic } from './config';

// small utility library to cache data needed for every statically built page
// Prismic's Website and

const CACHE_KEY = 'arsskyrsla_dev_cache';
const inMemoryCache = new Map<string, { v: string; d: number }>();
let redisClient: any;

export function getRedisClient() {
  try {
    if (!redisClient && typeof window === 'undefined') {
      const redis = require('redis');
      const opts = {
        url: prismicConfic.REDIS_URL,
        password: prismicConfic.REDIS_PASSWORD ?? undefined,
      };

      redisClient = redis.createClient(opts);
    }
  } catch (err) {
    console.error(err);
  }
  // noop
  if (!redisClient) {
    redisClient = {
      get(k: any, fn: any) {
        const { v, d } = inMemoryCache.get(k) || {};
        return fn(undefined, d && d > Date.now() ? undefined : v);
      },
      setex(k: any, v: any, ex = 60, fn: any) {
        inMemoryCache.set(k, { v, d: Date.now() + ex });
        return fn(undefined, true);
      },
    };
  }
  return redisClient;
}

export function get(key: string): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      getRedisClient().get(key, (err: Error | undefined, res: any) => {
        if (err) {
          reject(err);
        }
        resolve(res);
      });
    } catch (err) {
      reject(err);
    }
  });
}

export function set(key: string, value: string, expire = 60): Promise<boolean> {
  return new Promise((resolve, reject) => {
    try {
      getRedisClient().setex(
        key,
        expire,
        value,
        (err: Error | undefined, res: any) => {
          if (err) {
            reject(err);
          }
          resolve(res);
        },
      );
    } catch (err) {
      reject(err);
    }
  });
}

export async function getInitialState() {
  if (typeof window !== 'undefined' && prismicConfic.REDIS_URL !== '') {
    try {
      return JSON.parse(await get(CACHE_KEY));
    } catch (err) {
      // noop
    }
  }
  return undefined;
}

export async function setInitialState(cache: ApolloCache<any>) {
  if (typeof window !== 'undefined' && prismicConfic.REDIS_URL !== '') {
    try {
      await set(CACHE_KEY, JSON.stringify(cache.extract()), 120); // 120 sec
    } catch (err) {
      // noop
    }
  }
}

export const rclient = { get, set };
